<template>
  <div>
    <b-row>
      <b-col>
        <v-select
          label="Ano"
          outlined
          dense
          :items="p_years"
          v-model="year"
          @change="getGeolocationAmount"
        />
      </b-col>

      <b-col>
        <v-select
          label="Mês"
          outlined
          dense
          clearable
          :items="p_months"
          v-model="month"
          @change="getGeolocationAmount"
        >
          <template v-slot:item="{ item }">
            {{ months[item].name }}
          </template>
          <template v-slot:selection="{ item }">
            {{ item ? months[item].name : "Todos" }}
          </template>
        </v-select>
      </b-col>

      <b-col>
        <v-text-field
          outlined
          dense
          append-icon="mdi-currency-usd"
          label="Valor Dolar Atual"
          :loading="loading"
          type="text"
          v-model="valueDollar"
          v-on:keyup="handleDollarValue"
          placeholder="0.00"
          @blur="getGeolocationAmount"
        />
      </b-col>
    </b-row>

    <b-overlay :show="loading" opacity="0.99">
      <v-data-table
        dense
        :headers="headers"
        :items="records"
        :footer-props="{
          'items-per-page-options': [100, 200, 300],
          'items-per-page-text': 'Mostrar',
        }"
      >
        <template v-slot:[`item.month`]="{ item }">
          {{ formatMonth(item.month) }}
        </template>

        <template v-slot:[`item.total`]="{ item }">
          {{ item.total }}
        </template>
        
        <template v-slot:[`item.valueReal`]="{ item }">
          R$ {{ formatCurrency(item.valueReal) }}
        </template>

        <template v-slot:no-data>
            Nenhum registro encontrado
        </template>
      </v-data-table>
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";

import moment from "moment";

import {
  formatDate,
  formatValueOnKeyUp,
  formatCurrency,
} from "../../functions/format";

export default {
  name: "RestHomeGeolocation",

  data() {
    return {
      headers: [
        { text: "Mês", value: "month" },
        {
          text: "Quantidade de vizualizações de mini mapa",
          value: "total",
        },
        {
          text: "Valor a pagar em reais (aproximadamente)",
          value: "valueReal",
        },
      ],

      rest_home_id: "",

      loading: false,

      records: [],

      month: null,

      year: moment().year(),

      p_months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],

      p_years: [],

      valueDollar: null,

      months: {
        1: { name: "Janeiro" },
        2: { name: "Fevereiro" },
        3: { name: "Março" },
        4: { name: "Abril" },
        5: { name: "Maio" },
        6: { name: "Junho" },
        7: { name: "Julho" },
        8: { name: "Agosto" },
        9: { name: "Setembro" },
        10: { name: "Outubro" },
        11: { name: "Novembro" },
        12: { name: "Dezembro" },
      },
    };
  },

  mounted() {
    for (let year = 2025; year <= this.year; year++) {
      this.p_years.push(year);
    }
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    moment,
    formatValueOnKeyUp,
    formatCurrency,

    retrieve() {
      const { id } = this.$attrs;

      this.rest_home_id = id;

      this.getGeolocationAmount();
    },

    async getGeolocationAmount() {
      try {
        this.loading = true;

        const { rest_home_id, month, year } = this;

        const valueDollar = this.getNumericValueDollar();

        let params = {
          rest_home_id,
          month,
          year,
          valueDollar,
        };

        const response = await api.get(
          "/admin/rest-home/geolocation/amount-all",
          {
            params,
          }
        );

        const { error, records } = response.data;

        if (!error) {
          this.records = records;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    formatMonth(dateString) {
      const date = new Date(dateString);
      const options = { year: "numeric", month: "long" };
      return date.toLocaleDateString("pt-BR", options);
    },

    handleDollarValue: function (e) {
      this.valueDollar = formatValueOnKeyUp(e.target.value);
    },

    getNumericValueDollar() {
      const value = this.valueDollar || "0";
      return parseFloat(value.replace(/\./g, "").replace(",", ".")) || 0;
    },
  },
};
</script>